import { mapProductBoxProps } from "./internal";
export var mapProductBoxPropsFromStaticApi = function mapProductBoxPropsFromStaticApi(data) {
  return mapProductBoxProps(data);
};
//# sourceMappingURL=mapProductBoxPropsFromStaticApi.js.map